import qa from './config/qa/config';
import prod from './config/prod/config';
import e2e from './config/e2e/config';
import dev from './config/dev/config';

// Default to dev if not set
let config = {};

const APP_STAGE = process.env.REACT_APP_STAGE;

switch(APP_STAGE) {
    case 'prod':
        config = prod;
        break;
    case 'qa':
        config = qa;
        break;
    case 'e2e':
        config = e2e;
        break;
    case 'dev':
        config = dev;
        break;
}
export const urlConfig = config;
export const bffUrl= urlConfig.bffUrl;
export const momentsServiceUrl= urlConfig.momentsServiceUrl;
export const thumbnailUrlBase= urlConfig.thumbnailUrlBase;
export const contextServiceUrl= urlConfig.contextServiceUrl;
export const drmServiceUrl = urlConfig.drmServiceUrl;
export const cmsURL = urlConfig.cmsURL;
export const microdramaFileUploadUrl = urlConfig.microDramaFileUploadUrl;